import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María C.',
  location: 'Miami, FL',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  before: 'Antes yo vivía cansada y a dieta constante sin ver resultados reales.',
  after: 'Hoy después de RenuevaTE_90 tengo más energía que a mis 20s, como delicioso sin culpa y mi ropa me queda increíble. Es un cambio de vida total.'
}, {
  name: 'Elena R.',
  location: 'Bogotá, COL',
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1bf98c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  before: 'Antes yo sentía que mi cuerpo era mi enemigo después de los 40.',
  after: 'Hoy después de RenuevaTE_90 aprendí a escucharme. Las rutinas son un placer y no un castigo. Recuperé mi confianza y mi paz mental.'
}, {
  name: 'Sofía T.',
  location: 'Madrid, ESP',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  before: 'Antes yo sabía qué comer pero la ansiedad me ganaba por las tardes.',
  after: 'Hoy después de RenuevaTE_90 entiendo mis emociones. El pilar de mentalidad fue clave. Llevo 6 meses manteniendo mis resultados sin esfuerzo.'
}];
export function Testimonials() {
  return <section className="py-24 bg-cream relative" data-id="element-226">
      <div className="max-w-6xl mx-auto px-6" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-228">
          <h2 className="font-serif text-3xl md:text-5xl mb-6 text-[#0D1B3E]" data-id="element-229">
            Historias de Transformación Real
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-230"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-231">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-navy/5 relative" data-id="element-232">
              <div className="flex gap-1 mb-6" data-id="element-233">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-234" />)}
              </div>

              <div className="space-y-4 mb-8" data-id="element-235">
                <p className="text-navy/60 italic text-sm" data-id="element-236">
                  <span className="font-semibold text-red-500/80" data-id="element-237">Antes:</span>{' '}
                  "{test.before}"
                </p>
                <p className="font-medium text-lg leading-relaxed text-[#0D1B3E]" data-id="element-238">
                  <span className="font-semibold text-green-600/80" data-id="element-239">Hoy:</span>{' '}
                  "{test.after}"
                </p>
              </div>

              <div className="flex items-center gap-4 mt-auto border-t border-navy/10 pt-6" data-id="element-240">
                <img src={test.image} alt={test.name} className="w-12 h-12 rounded-full object-cover border-2 border-gold" data-id="element-241" />
                <div data-id="element-242">
                  <h4 className="font-serif font-bold text-[#0D1B3E]" data-id="element-243">
                    {test.name}
                  </h4>
                  <p className="text-navy/50 text-sm" data-id="element-244">{test.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}